
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Navbar extends Vue {
  @Prop(Number) current_step!: any;

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
